import React, { useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { attach } from "../../common/componentExtensions";
import CustomerForm from "./tipoContrattoForm";
import TipiContrattoActions from "../tipiContrattoActions";
import TipiContrattoStore from "../tipiContrattoStore";
import { TipoContratto } from "../../generated";
import { links } from "../../routes";
import { Loading } from "../../common/components/loading";


interface Props extends RouteComponentProps<{ id?: string }> {
    tipoContratto?: TipoContratto;
}
const TipoContrattoEdit = (props: Props) => {
    let { tipoContratto, history, match } = props;
    const { id } = match.params;

    useEffect(() => {
        if (TipiContrattoStore.get(id!) == null)
            TipiContrattoActions.getAll();
    }, [id])

    const save = (customer: TipoContratto) => {
        if (id)
            TipiContrattoActions.update(customer);
        else
            TipiContrattoActions.add(customer);
        history.push(links.tipiContratto)
    }


    if (!id)
        tipoContratto = new TipoContratto();
    else if (!tipoContratto) {
        return <Loading />;
    }

    return (
        <div className="card">
            <div className="card-body">
                <CustomerForm
                    customer={tipoContratto}
                    onSubmit={save}
                    onCancel={() => history.goBack()}
                />
            </div>
        </div>
    );
}


export default withRouter(attach(TipoContrattoEdit, TipiContrattoStore, (store, props) => ({ tipoContratto: store.get(props.match.params.id!) ?? undefined })));